import React from 'react';
import Nav from '../Components/Nav';
import Footer from '../Components/Footer';
import Downloads from '../Components/Downloads';
import Card from '../Components/Card';
import DuCo from '../Assets/pfps/DuCo.png';
import Jelly from '../Assets/pfps/Jelly.png';
import 'animate.css';
import {
    MDBCard,
    MDBCardBody,
    MDBCardTitle,
    MDBCardText,
    MDBContainer,
    MDBRow,
    MDBCol
} from 'mdb-react-ui-kit';


export default function About() {

    return (
        <MDBContainer fluid className="text-center text-black mt-5">
            <Nav />
                <MDBCard alignment='center' className='slideUp mx-auto mt-5' style={{width: '85vw', backgroundColor: 'rgba(120, 120, 120, .5)', border: '1px solid rgba(168, 168, 168, .5)', borderRadius: '10px'}}>
                    <MDBCardBody>
                        <MDBCardTitle>About Us</MDBCardTitle>
                        <MDBCardText className='about-us mx-2 fs-5'>
                            We are the company developing h.Society, a play & earn game built on Unreal Engine 5 and Hedera Hashgraph.<br/>
                            We will also be providing a platform for content creators and developers to launch and create on. <br/>
                            Contact Us today and tell us about your project. <br/>
                            To find more information on h.Society, download the h.Society Litepaper & Road Map pdfs below.
                        </MDBCardText>
                    </MDBCardBody>
                    <MDBRow between className="my-3">
                        <MDBCol className="col-md-12" >
                        </MDBCol>
                        <MDBCol className="d-flex justify-content-center col-md-12">
                            <Downloads className="about-us" />
                        </MDBCol>
                    </MDBRow>
                    <MDBCardTitle className="my-4">Meet the Team</MDBCardTitle>
                    <MDBRow className="mb-3">
                        <MDBCol className="col-12 col-lg-6 mb-3">
                            <Card
                            style={{maxWidth: '70%', backgroundColor: 'rgba(120, 120, 120, .5)', border: '1px solid rgba(168, 168, 168, .5)', borderRadius: '10px'}}
                            className='mx-auto'
                            name='DuCo'
                            img={DuCo}
                            about={<li>Founder/ Developer/ Artist</li>}
                            />  
                        </MDBCol>
                        <MDBCol className="col-12 col-lg-6">
                            <Card
                            style={{maxWidth: '70%', backgroundColor: 'rgba(120, 120, 120, .5)', border: '1px solid rgba(168, 168, 168, .5)', borderRadius: '10px'}}
                            className='mx-auto'
                            name='Jelly'
                            img={Jelly}
                            about={<li>Founder/ Developer/ Artist</li>}
                            />  
                        </MDBCol>
                    </MDBRow>
                </MDBCard>
            <Footer />
        </MDBContainer>  
    );
}